import { type ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MotionConfig } from 'framer-motion';
import { Toaster } from '@/components/ui/toaster';
import { usePrefersReducedMotion } from '@/lib/useReducedMotion';
import { useSyncTheme } from '@/stores/theme.store';

function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}

let queryClient: QueryClient | undefined;

export function AppProviders({ children }: { children: ReactNode }) {
  const reducedMotion = usePrefersReducedMotion();
  useSyncTheme();
  queryClient ??= createQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <MotionConfig reducedMotion={reducedMotion ? 'always' : 'never'}>
        {children}
        <Toaster />
      </MotionConfig>
    </QueryClientProvider>
  );
}
